import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Typography, CircularProgress } from '@mui/material';
import {
  makeSaleMngCostData,
  makeSalesMngCostHeader,
} from '../../utils/sales_mng_cost_stats';
import SalesMngCostStatsTable from '../../components/sales_mng_cost_stats/SalesMngCostStatsTable';

//----------------------------------------------------------------------
const SalesMngCostStatsEmpContainer = ({
  selectedYear,
  selectedUser,
  tableRef,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  useEffect(() => {
    if (selectedYear && selectedUser) {
      const headers = makeSalesMngCostHeader();
      setHeaderRows(headers);
      // console.log(headers, 'headers');
      const tempData = makeSaleMngCostData();
      console.log(JSON.stringify(tempData));
      setData(tempData);
    }
  }, [selectedYear, selectedUser]);

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      {!selectedUser ? (
        <Box>
          <Typography variant="subtitle2">임직원을 선택하세요</Typography>
        </Box>
      ) : loading ? (
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      ) : Array.isArray(data) && data.length === 0 ? (
        <Box>
          <Typography variant="subtitle2">데이터가 없습니다.</Typography>
        </Box>
      ) : (
        <SalesMngCostStatsTable
          data={data}
          loading={loading}
          headerRows={headerRows}
          tableRef={tableRef}
        />
      )}
    </Box>
  );
};
//----------------------------------------------------------------------
export default SalesMngCostStatsEmpContainer;
